import { useMemo } from 'react';
import { useTranslation } from '../../../../../translations';
import checkProfanity from '../../utils/checkProfanity';
import checkAvailableSymbols from '../../utils/checkAvailableSymbols';
import { FOR_ID, FOR_NAME } from '../../constants/modalTypes';
import { useWishes } from '../../../../../redux/reducer/content';

export default function useFormProps({ input, badWords, wishType, defaultValue }) {
  const { t } = useTranslation();

  return useMemo(
    () =>
      ({
        [FOR_NAME]: {
          ...input,
          defaultValue,
          rules: {
            ...input.rules(t, 1, 10),
            validate(value) {
              const isHasNotAvailableSymbols = checkAvailableSymbols(value);
              if (isHasNotAvailableSymbols) return t(input?.notAvailableSymbolsText);
              const isHasBadWords = checkProfanity(value, badWords);
              if (isHasBadWords) return t(input?.badWordText);
              return true;
            },
          },
        },
        [FOR_ID]: { ...input, rules: input.rules(t) },
      }[wishType]),
    [wishType, badWords],
  );
}
